<div class="stf-group-list">
  <div class="row unselectable"
    style="width: 98%; margin: 10px auto; box-shadow: 2px 2px 6px; background-color: rgb(240, 248, 254);">
    <div class="col-12 col-md-12">
      <!-- Title -->
      <h2 class="section-title text-center" style="margin-bottom: -8px;">{{"Automation Test Summary" | translate}}</h2>

      <!-- Main Container for the sections -->
      <div class="content-container d-flex flex-wrap">
        <!-- Date and Filters Section -->
        <div class="section filter-section">
          <!-- Date Range Inputs -->
          <div class="date-range-inputs">
            <div class="date-group">
              <label for="fromDate" class="date-label">{{"From:" | translate }}</label>
              <input
                id="fromDate"
                type="date"
                [(ngModel)]="fromDate"
                (input)="handleDateChange()"
                [max]="toDate"
                class="date-input"
                />
            </div>
            <div class="date-group">
              <label for="toDate" class="date-label">{{"To:" | translate}}</label>
              <input
                id="toDate"
                type="date"
                [(ngModel)]="toDate"
                (input)="handleDateChange()"
                [min]="fromDate"
                [max]="currentDate"
                class="date-input"
                />
            </div>
          </div>

          <!-- Filter Dropdowns -->
          <div class="filter-dropdowns">
            <select id="device" [(ngModel)]="filterDevice" (ngModelChange)="doFilter()" class="filter-select">
              <option value="All" selected>{{"Devices (All)" | translate}}</option>
              @for (device of deviceList; track device) {
                <option [value]="device">{{ device }}</option>
              }
            </select>
            <select id="status" [(ngModel)]="filterStatus" (ngModelChange)="doFilter()" class="filter-select">
              <option value="All" selected>{{"Status (All)" | translate}}</option>
              @for (status of statusList; track status) {
                <option [value]="status">{{ status | translate }}</option>
              }
            </select>
          </div>

          <!-- Date Range Buttons -->
          <div class="date-range-buttons">
            <button (click)="setDateRange(7)" class="range-button">{{"7 Days" | translate}}</button>
            <button (click)="setDateRange(30)" class="range-button">{{"1 Month" | translate}}</button>
            <button (click)="setDateRange(180)" class="range-button">{{"6 Months" | translate}}</button>
            <button (click)="setDateRange(365)" class="range-button">{{"1 Year" | translate}}</button>
          </div>

        </div>

        <!-- Pie Chart and Test Summary Section -->
        <div class="section pie-chart-section d-flex">
          <div id="piechart" class="flex-grow-1"></div>
          <div id="showdresult" class="test-summary ms-3">
            <div class="row">
              <div class="col-12 col-md-12 mb-1">
                <div class="card p-1 rounded">
                  <div class="card-body text-center">
                    <span class="running">{{"Running:" | translate}} {{running}}</span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 mb-1">
                <div class="card p-1 rounded">
                  <div class="card-body text-center">
                    <span class="completed">{{"Completed:" | translate}} {{completed}}</span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 mb-1">
                <div class="card p-1 rounded">
                  <div class="card-body text-center">
                    <span class="timed-out">{{"Timed-out:" | translate}} {{timedOut}}</span>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-12 mb-1">
                <div class="card p-1 rounded">
                  <div class="card-body text-center">
                    <span class="stopped">{{"Stopped:" | translate}} {{stopped}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Appium Logs Section -->
        @if (isAppiumLogs) {
          <div id="detailLog">
            <div class="log-container">
              <!-- Add a close button -->
              <button class="close-btn" (click)="closeLogs()">×</button>
              <h2 style="text-shadow: 2px 2px 5px #141d48;">{{"Appium Logs" | translate}}</h2>
              <table class="table-striped">
                <thead>
                  <tr>
                    <th style="width: 120px;">{{"Timestamp" | translate}}</th>
                    <th style="width: 100px;">{{"Type" | translate}}</th>
                    <th style="width: 400px;">{{"Step Description" | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (log of appiumLogs; track log) {
                    <tr>
                      <td style="width: 120px;">{{ log.timestamp }}</td>
                      <td style="width: 100px;">{{ log.type }}</td>
                      <td style="width: 400px;">{{ log.stepDescription }}</td>
                    </tr>
                  }
                  @if (appiumLogs.length === 0) {
                    <tr>
                      <td colspan="3" class="no-logs">
                        {{"No logs available" | translate}}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }

      </div>
    </div>
  </div>



  <!-- logtables -->

  <div id="logTable" class="row" style="height: 317px; width: 100%; margin-left: inherit;">
    <div class="col-12 col-md-12" id="logstbales">
      <!-- Container for the entire table -->
      <div class="table-container" style="position: relative; height: 23em; margin-top: 10px;overflow-y: auto;">
        <table class="table table-bordered table-striped" style="width: 100%;">
          <!-- Fixed Header -->
          <thead style="position: sticky; top: 0; background: rgb(2, 42, 112); z-index: 1000;">
            <tr>
              <th style="width: 14%;" class="header-cell">{{"Test Name" | translate}}</th>
              <th style="width: 14%;" class="header-cell">{{"Last Updated" | translate}}</th>
              <th style="width: 14%;" class="header-cell">{{"Device" | translate}}</th>
              <th style="width: 14%;" class="header-cell">{{"Version" | translate}}</th>
              <th style="width: 14%;" class="header-cell">{{"Duration" | translate}}</th>
              <th style="width: 14%;" class="header-cell">{{"Status" | translate}}</th>
              <th style="width: 16%;" class="header-cell">{{"Action" | translate}}</th>
            </tr>
          </thead>
          <tbody
            style="position: relative; display:table-row-group; max-height: 300px; overflow-y: scroll; width: 100%;">
            @for (data of paginatedLogs; track data) {
              <tr>
                <td>{{data.name}}</td>
                <td>{{data.lastUpdated}}</td>
                <td>
                  <i style="color:cornflowerblue; font-family: 'DM Sans';" class="fa">&nbsp;</i>{{data.deviceName}}
                </td>
                <td>
                  @if (data.platformName.toUpperCase()==='IOS') {
                    <span>
                      <i class="fa" style="color:#47d74b;">&#xf179;&nbsp;</i>
                      {{data.platformName | uppercase}} {{data.platformVersion}}
                    </span>
                  }
                  @if (data.platformName.toUpperCase()==='ANDROID') {
                    <span>
                      <i class="fa" style="color:#47d75b;">&#xf17b;&nbsp;</i>
                      {{data.platformName | uppercase}} {{data.platformVersion}}
                    </span>
                  }
                </td>
                <td>
                  {{ floor(data.duration / 60) }}m {{ data.duration % 60 }}s
                </td>
                <td (click)="showDetailedLog(data)" style="cursor: pointer;">
                  @if (data.status==='TIMED OUT') {
                    <span id="timed-out" style="color:#917210">
                      <i class="fa">&#xf071;</i>
                      &nbsp;{{data.status}}
                    </span>
                  }
                  @if (data.status==='COMPLETED') {
                    <span id="completed" style="color:#0e8a09!important">
                      <i class="fa">&#xf058;</i>
                      &nbsp;{{data.status}}
                    </span>
                  }
                  @if (data.status==='RUNNING') {
                    <span id="running" style="color:#297ee2;">
                      <i class="fa fa-spin">&#xf110;</i>
                      &nbsp;{{data.status}}
                    </span>
                  }
                  @if (data.status==='STOPPED') {
                    <span id="stopped" style="color:red">
                      <i class="fa">&#xf057;</i>
                      &nbsp;{{data.status}}
                    </span>
                  }
                </td>
                <td style="font-size:16px;">
                  <i class="fa fa-download" (click)="downloadLogFile(data.logPath, data.appiumUrl)"
                  style="cursor:pointer;"></i>&nbsp;&nbsp;
                  <i class="fa viewLog" (click)="viewLogFile(data.logPath, data.appiumUrl)"
                  style="cursor:pointer;">&#xf06e;</i>&nbsp;&nbsp;
                  <i class="fa deleteLog" (click)="deleteLog(data)" style="cursor:pointer;">&#xf014;</i>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="pagination-controls" style="text-align: center; padding: 10px 0; margin-top: 10px;">
        <button (click)="prevPage()" class="pagination-btn prev-btn" [class.disabled]="currentPage === 1">
          {{"Previous" | translate}}
        </button>
        <span class="pagination-info">Page {{ currentPage }} of {{ totalPages }}</span>
        <button (click)="nextPage()" class="pagination-btn next-btn" [class.disabled]="currentPage === totalPages">
          {{"Next" | translate}}
        </button>
      </div>
    </div>
  </div>









  <!-- hinden logdatils -->
  <!-- <div id="detailLog"> -->
  <!-- <div class="col-md-12" [style.width]="'1210px'" [style.margin-bottom]="'20px'">
  <div class="row logHeader">
    <div class="col-md-1">
      <button id="back" (click)="showLogTable()">
        <i class="fa fa-arrow-left" aria-hidden="true"></i>
      </button>
    </div>
    <div class="col-md-11 logHeaderData">
      <span>Test Name: {{activeLogData.name}}</span>
      <span>Device: {{activeLogData.deviceName}}</span>
      <span>Version: {{activeLogData.platformName}}{{activeLogData.platformVersion}}</span>
      <span>Last Updated:{{activeLogData.lastUpdated}}</span>
    </div>
  </div>

  <div class="row logData" *ngIf="loglist.length == 0">
    <span class="logData" style="color: red;">No Data Available !!</span>
  </div> -->

  <!-- // need to check this code -->
  <!-- <div class="Logs" *ngFor="let log of loglist; let i = index">
  <div class="logData">
    <div class="col-md-2 logData">
      <span>{{ log[0] }}</span>
    </div>
    <div class="col-md-1 logData">
      <span class="logDuration"
      [ngStyle]="{'background': log[4] ? (log[4][0] == 200 ? 'green' : 'red') : 'white'}">{{ log[1] }}</span>
    </div>
    <div class="col-md-8 logText">
      <span>
        <span>{{ log[2] }}&nbsp;&nbsp;&nbsp;</span>
        <span class="logText">{{ log[3] }}</span>
      </span>
    </div>
    <div class="col-md-1" id="time">
      <span>
        <i class="fa">&#xf017;</i> {{ log[5] ? log[5] : 0 }}s
      </span>
      <span>
        <i id="expand{{ i }}" *ngIf="log[4]" class="fa fa-plus" (click)="showResDiv(i)" aria-hidden="true"></i>
        <i id="collapse{{ i }}" (click)="hideResDiv(i)" style="display: none;" class="fa fa-minus"
        aria-hidden="true"></i>
      </span>
    </div>
  </div>

  <div id="res{{ i }}" class="logData" style="display: none;">
    <div class="col-md-10 logData" style="border: 1px dotted; padding: 20px;">
      <h5 style="word-break: break-word;">{{ log[4] ? log[4][1] : '' }}</h5>
    </div>
  </div>
</div> -->
<!-- </div>
</div> -->


<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>